module.exports = __webpack_public_path__ + "static/media/jpg-crew-2026.78e31f60.png";